/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum CodeExceptionStatus {
  ENTITY_NOT_FOUND = 'entity_not_found',
  VOUCHER_STATUS_ERROR = 'voucher_status_error',
  VOUCHER_USED = 'voucher_used',
  VOUCHER_TOO_OLD = 'voucher_too_old',
  ORDER_NOT_MATCH_VOUCHER = 'order_not_match_voucher',
  CODE_NOT_FOUND = 'code_not_found',
  DISCOUNT_NOT_ACTIVE = 'discount_not_active',
  DISCOUNT_USAGE_LIMIT_EXCEEDED = 'discount_usage_limit_exceeded',
  RETURNING_CUSTOMER_TOO_LATE = 'returning_customer_too_late',
  DISCOUNT_ORDER_PAGE_NOT_VALID = 'discount_order_page_not_valid',
  ORDER_DATE_BEFORE_REDEMPTION_PERIOD = 'order_date_before_redemption_period',
  ORDER_DATE_AFTER_REDEMPTION_PERIOD = 'order_date_after_redemption_period',
  DISCOUNT_NOT_VALID_FOR_ORDERS = 'discount_not_valid_for_orders',
  DISCOUNT_NOT_VALID_FOR_VOUCHERS = 'discount_not_valid_for_vouchers',
  DISCOUNT_ALREADY_USED = 'discount_already_used',
  DISCOUNT_MINIMUM_AMOUNT_NOT_REACHED = 'discount_minimum_amount_not_reached',
  PASS_STATUS_ERROR = 'pass_status_error',
  PASS_EXPIRED = 'pass_expired',
  PASS_NOT_STARTED = 'pass_not_started',
  PASS_FULLY_USED = 'pass_fully_used',
  PASS_NOT_VALID_FOR_ORDER_PAGE = 'pass_not_valid_for_order_page',
  PASS_NOT_VALID_FOR_COURSE = 'pass_not_valid_for_course',
  PASS_SLOT_AT_CAPACITY = 'pass_slot_at_capacity',
  PASS_DATED_SESSION_UNAVAILABLE = 'pass_dated_session_unavailable',
  VOUCHER_LIMIT_REACHED = 'voucher_limit_reached',
  VOUCHER_INSUFFICIENT_BALANCE = 'voucher_insufficient_balance',
  VOUCHER_REDEMPTION_LIMIT_REACHED = 'voucher_redemption_limit_reached',
  VOUCHER_ALREADY_APPLIED = 'voucher_already_applied',
  VOUCHER_CURRENCY_MISMATCH = 'voucher_currency_mismatch',
  VOUCHER_NOT_VALID_FOR_MEMBERSHIP = 'voucher_not_valid_for_membership',
  ORDER_NOT_AWAITING_PAYMENT = 'order_not_awaiting_payment',
  CODE_NOT_VALID_FOR_PAYMENT_LINK = 'code_not_valid_for_payment_link',
}
